<template>
    <client-page>
        <div id="contents">
            <v-container>
                <div class="title-wrap title-wrap--line">
                    <h2 class="font-42">library board</h2>
                </div>
                <library-list></library-list>
            </v-container>
        </div>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import LibraryList from "@/components/client/en/board/library/list.vue"

export default {
    components: {
        ClientPage,
        LibraryList
    },
};
</script>